/**
 * Rounds a price value to 2 decimal places to prevent floating-point precision issues
 * @param {string|number} value - The price value to round
 * @returns {string} - The rounded price as a string with 2 decimal places
 */
export const roundPrice = (value) => {
  const rounded = Math.round(parseFloat(value) * 100) / 100;
  return rounded.toFixed(2);
};
